import { Component, inject, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormulaireMouvementService } from '@services/formulaire-mouvement/formulaire-mouvement.service';
import { RequeteCoordonneesMouvementService } from '@services/requete-coordonnees-mouvement/requete-coordonnees-mouvement.service';
import { NavigationService } from '@services/navigation/navigation.service';
import { GabaritService } from '@services/gabarit/gabarit.service';
import { GlobalStoreService } from '@services/global-store/global-store.service';
import { FormulaireCoordonneesMouvementTelephoneModel } from '../../models/formulaire/formulaire-coordonnees-mouvement-telephone.model';
import { TelephoneMouvement } from '../../api/model/telephone-mouvement.model';
import { GestionTitreService } from '@services/navigation/gestion-titre.service';
import { TypeModificationEnum } from 'src/app/constantes/type-modification.enum';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../constantes/cybermetrie.enum';
import { AccessibiliteService } from '@services/accessibilite.service';

@Component({
  selector: 'app-page-validation',
  templateUrl: './page-validation-telephone.component.html',
  standalone: false,
})
export class PageValidationTelephoneComponent implements OnInit, AfterViewInit {
  isAppMobile?: boolean;
  form?: FormGroup<FormulaireCoordonneesMouvementTelephoneModel> | null;

  private readonly formulaireMouvementService = inject(FormulaireMouvementService);
  private readonly requeteCoordonneesMouvementService = inject(RequeteCoordonneesMouvementService);
  private readonly navigationService = inject(NavigationService);
  private readonly gabaritService = inject(GabaritService);
  private readonly globalStoreService = inject(GlobalStoreService);
  private readonly gestionTitreService = inject(GestionTitreService);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);
  private readonly accessibiliteService = inject(AccessibiliteService);

  ngOnInit(): void {
    this.gestionTitreService.addTitreOnglet('titreOnglet.pageValidation');
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.form = this.formulaireMouvementService.getFormTelephone();
    this.cybermetrieCoordonneesService.transactionEtape(
      this.form?.value.telephoneExistant
        ? CybermetrieEnum.LABEL_MODIFIER_TELEPHONE
        : CybermetrieEnum.LABEL_MODIFIER_TELEPHONE_AJOUT,
    );
  }

  ngAfterViewInit(): void {
    this.accessibiliteService.setFocus('#titreValidationTelephone');
  }

  get telephone(): TelephoneMouvement {
    return {
      numeroTelephone: this.form?.value.numeroTelephone ?? null,
      typeAppareil: this.form?.value.typeAppareil ?? null,
      numeroPoste: this.form?.value.numeroPoste ?? null,
    } as TelephoneMouvement;
  }

  naviguerVersModifier(): void {
    this.navigationService.naviguerVersModifierTelephone();
    this.cybermetrieCoordonneesService.actionClick(
      CybermetrieEnum.LABEL_MODIFIER_TELEPHONE_VALIDATION,
    );
  }

  naviguerVersConfirmation(): void {
    const requete = this.requeteCoordonneesMouvementService.construireRequeteModifierTelephone();
    this.globalStoreService.modifierCoordonneMouvement$(requete).subscribe({
      next: () => {
        this.navigationService.naviguerVersConfirmationTelephone(this.typeModification());
      },
    });
  }

  annuler(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }

  typeModification(): TypeModificationEnum {
    return this.form?.getRawValue().telephoneExistant
      ? TypeModificationEnum.MODIFICATION
      : TypeModificationEnum.AJOUT;
  }
}
